import type RootState from 'app-components/utils/redux-store/rootState';
import { HOUSINGSELECTION_REDUCER_KEY } from './housingSelectionTypes';
type State = Pick<RootState, typeof HOUSINGSELECTION_REDUCER_KEY>;

export const getHousingSelectionStore = (state: State) => state[HOUSINGSELECTION_REDUCER_KEY];
export const getHousingSelectionById = (state: State) => getHousingSelectionStore(state).resourcesById;
export const getHousingSelectionIsLoading = (state: State) => getHousingSelectionStore(state).isLoading;
export const getResourcesById = (state: State) => getHousingSelectionStore(state).resourcesById;
export const getIsLoading = (state: State) => getHousingSelectionStore(state).isLoading;
export const getError = (state: State) => getHousingSelectionStore(state).error;
